/**
 * New typescript file
 */
export function validarTelefone(ddd: string, numero: string, tipo: string, addValidateMessage?): boolean {
    var valido: boolean = true;

    if (ddd == null || ddd.trim() == '') {
        if (addValidateMessage != null)
            addValidateMessage('- Informe o <b>DDD</b> do ' + tipo + '.');
        valido = false;
    } else if (!ddd.match('[1-9][0-9]')) {
        if (addValidateMessage != null)
            addValidateMessage('- <b>DDD</b> do telefone ' + tipo + ' inválido.');
        valido = false;
    }

    if (numero == null || numero.trim() == '') {
        if (addValidateMessage != null)
            addValidateMessage('- Informe o <b>Número</b> do ' + tipo + '.');
        valido = false;
    }else if (!numero.match('[1-9][0-9]{' + (tipo == 'celular' ? 8 : 7) + '}')) {
        if (addValidateMessage != null)
            addValidateMessage('- <b>Nº do telefone ' + tipo + '</b> inválido.');
        valido = false;
    }
    return valido;
}

export function getDddTelefone(telefone: string): Object {
    var ddd = null;
    var numero = null;
    if (telefone != null) {
      telefone = telefone.trim().replace(new RegExp('(-|\\s|\\(|\\))', 'g'), '');
      if (telefone != '') {
        var dddLength: number = (telefone.length >= 2 ? 2 : telefone.length);
        ddd = telefone.substring(0, dddLength);
        numero = (telefone.length > dddLength ? telefone.substring(2, telefone.length) : null);
      }
    }

    return {
      ddd: ddd,
      numero: numero
    }
  }


// WEBPACK FOOTER //
// ./src/util/telefoneutil.ts